<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-card-actions>
              <v-text-field
                class="search-box"
                placeholder="Search Users"
                prepend-icon="fa-search"
                v-model="search"
                type="text"
                clearable
                clear-icon="fa-times"
                @click:clear="resetSearch"
                @change="applySearch"
              ></v-text-field>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-card-title>
              <div class="flex-grow-1"></div>
            </v-card-title>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="users"
            >
              <template v-slot:item.confirmed="{ item }">
                <v-icon v-if="item.confirmed" color="primary">fa-check</v-icon>
                <v-icon v-else color="error">fa-times</v-icon>
              </template>
              <template v-slot:item.id="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :id="item.id"
                      v-on="on"
                      text
                      small
                      class="mr-1"
                      :to="'/partner/reports/'+routeId+'/user/' + item.id"
                    >
                      <v-icon small>fas fa-chart-line</v-icon>
                    </v-btn>
                  </template>
                  <span>User Course Report</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import { EventBus } from "@/event-bus.js";
import userAPI from "@/api/partner.js";
import LayoutBasic from "@/layouts/PartnerHub";
export default {
  name: "UsersReport",
  components: {
    LayoutBasic
  },
  data() {
    return {
      headers: [
        { text: "First Name", value: "first_name" },
        { text: "Surname", value: "last_name" },
        { text: "Email", value: "email" },
        { text: "Last Login", value: "last_login", sortable: false },
        { text: "Courses", value: "total_courses", sortable: false },
        { text: "Groups", value: "total_groups", sortable: false },
        { text: "Playlists", value: "total_channels", sortable: false },
        { text: "In Progress", value: "total_in_progress", sortable: false },
        { text: "Completed", value: "total_completed_courses", sortable: false },
        { text: '', value: 'id', align: 'end' },
      ],
      users: [],
      search: "",
      searchParams: "",
      pagination: {},
      options: {},
      loading: false,
      id: this.$route.params.id
    };
  },
  computed: {
    serverItemsLength: function() {
      return this.pagination.total;
    },
    itemsPerPage: function() {
      return this.pagination.per_page;
    },
    page: function() {
      return this.pagination.current_page;
    },
    params: function() {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    routeId() {
      return this.$route.params.id;
    }
  },
  watch: {
    options: {
      handler() {
        this.getUsers();
      },
      deep: true
    }
  },
  methods: {
    getUsers() {
      this.loading = true;
      userAPI.getOwners(this.params + '&type=user_report', this.searchParams, this.id).then(resp => {
        this.users = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
    resetSearch() {
      this.options.page = 1;
      this.searchParams = "";
      this.getUsers();
    },
    applySearch() {
      this.options.page = 1;
      this.searchParams =
        this.params +
        "&search=first_name:" +
        this.search +
        ";last_name:" +
        this.search;
      this.getUsers();
    }
  }
};
</script>
